import React, { memo, useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSideBar from "../shared/AdminSidebar";
import AdminHeader from "../shared/AdminHeader";
import { useSelector } from "react-redux";
import { setTitle } from "../../helpers/MetaTag";

const AdminLayout = ({ metaTitle }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const profile = useSelector((state) => state?.profile?.data);
  const settings = useSelector((state) => state?.settings?.data);
  const { session } = useSelector((state) => state?.authProvider);

  setTitle(
    `Plotics ${
      session?.user?.roleCode === "USER" ? "User" : "Admin"
    } | ${metaTitle}`
  );

  function favIconChange() {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = settings?.favicon?.url;
  }
  favIconChange();

  return (
    <>
      <div className="relative flex w-full h-screen overflow-hidden [&>*]:font-CanelaDeck">
        <div
          className={
            "fixed h-screen flex flex-col transition-all duration-200 z-60 bg-shades-05/30 " +
            (isMenuOpen
              ? "-translate-x-full lg:translate-x-0 w-60 lg:w-16"
              : "translate-x-0 w-60 lg:w-60")
          }
        >
          <div className="flex-shrink flex-grow">
            <AdminSideBar isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
          </div>
          <div className="flex-shrink-0">
            <AdminHeader profile={profile} />
          </div>
        </div>
        <div
          className={
            "relative w-full flex flex-col transition-all duration-200 " +
            (isMenuOpen ? "p-0 lg:pl-16" : "p-0 lg:pl-60")
          }
        >
          <div className="relative w-full h-full max-h-screen p-3 md:p-6 overflow-auto scroll-smooth scrollbar bg-shades-01 parent-container">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(AdminLayout);
